module.exports = __webpack_public_path__ + "img/mais_solucoes_horizontal.a5166268.svg";